export const SIDEBAR_EXPANDED_WIDTH = 240;
export const SIDEBAR_COLLAPSED_WIDTH = 64;
export const SIDEBAR_TRANSITION = 'width 225ms cubic-bezier(0.4, 0, 0.6, 1)';
